/* eslint-disable camelcase */
import cn from "classnames";
import { joinExisting } from "utils/strings";
import { EmployeeCardProps } from "./EmployeeCard";
import baseStyles from "./EmployeeCard.module.scss";
import styles from "./Featured.module.scss";

export const Featured = ({
    className,
    employee,
    layout,
    onClick,
    ...props
}: EmployeeCardProps) => {
    const {
        description,
        first_name,
        employee_photo,
        job_title,
        last_name,
        quote1,
    } = employee;
    const title = joinExisting([first_name, last_name]);
    return (
        <article
            className={cn(
                styles.wrapper,
                {
                    [styles["wrapper--reverse"]]: layout === "featured-left",
                },
                className
            )}
            {...props}
        >
            {!!employee_photo && (
                <figure className={cn(baseStyles.figure, styles.figure)}>
                    <svg
                        aria-hidden={true}
                        className={cn(styles.leaf, {
                            [styles["leaf--flipped"]]: layout === "featured-right",
                        })}
                        fill="none"
                        height="148"
                        role="presentation"
                        viewBox="0 0 116 148"
                        width="116"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M 24.087 46.407 C 31.673 14.15 63.972 -5.851 96.229 1.735 L 151.036 14.623 C 159.638
                            16.646 164.972 25.259 162.949 33.861 L 139.524 133.474 C 131.939 165.731 99.64 185.731
                            67.383 178.146 L 12.575 165.257 C 3.973 163.234 -1.36 154.621 0.663 146.02 L 24.087
                            46.407 Z"
                            fill="currentColor"
                        />
                    </svg>
                    <img className={baseStyles.image} src={employee_photo} alt={title} loading="lazy" />
                    {!!onClick && (
                        <figcaption className={baseStyles.figcap}>
                            <button
                                className={cn(baseStyles.cta, styles.cta)}
                                onClick={onClick}
                                type="button"
                            >
                                Learn More
                            </button>
                        </figcaption>
                    )}
                </figure>
            )}
            <div className={styles.body}>
                <h3 className={baseStyles.title}>{title}</h3>
                {!!job_title && <p className={baseStyles.subheading}>{job_title}</p>}
                <p className={baseStyles.description}>{description}</p>
                {!!quote1 && <p className={styles.quote}>{quote1}</p>}
            </div>
        </article>
    );
};
